<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kGDfv7/images/cover.jpg?1685327426000" alt="This image is the cover for the book When I'm Gone, Stone Trail Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When I'm Gone, Stone Trail Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>Stone Trail: Book Two</i></b></p><p>As New Year's approaches, a grieving Richie Tatten collects his dead sister’s belongings from the institution where she lived. The mystery of her suicide confounds him and adds to his growing frustration with the disappearance of his life partner, Albert, who vanished months earlier. Hoping to find answers, Richie heads to the small town of Stone Trail, but the unwelcoming citizens leave Richie reluctant to continue his search. Then new information about his sister’s death gives him a lead on Albert’s whereabouts—and thrusts him into the middle of a battle between magic and werewolves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amber Redd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f59194c